module.exports = __webpack_public_path__ + "static/trelock-logo-9f727a725b84c651a077ae6f7877be3c.png";